import { createSelector } from 'reselect';

const selectGlobalOrgRegistryMappings = (state: any) => state.globalOrgRegistryMappings;


export const selectGlobalOrgRegistryMappingsCurrentItem = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.current);

export const selectGlobalOrgRegistryMappingsListItems = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalOrgRegistryMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalOrgRegistryMappingsQueryItems = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.query);

export const selectGlobalOrgRegistryMappingsCreatedItem = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.create);

export const selectGlobalOrgRegistryMappingsUpdatedItem = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.update);

export const selectGlobalOrgRegistryMappingsReadItem = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.read);

export const selectGlobalOrgRegistryMappingsDeletedItem = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.delete);

export const selectGlobalOrgRegistryMappingsSearchedItems = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.search);

export const selectGlobalOrgRegistryMappingsItemsCount = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.count);

export const selectGlobalOrgRegistryMappingsItemsFilter = createSelector([selectGlobalOrgRegistryMappings], (globalOrgRegistryMappings) => globalOrgRegistryMappings.filter);